import { useEffect } from 'react';

export const APP_DOCUMENT_TITLE = 'WEVO Management Portal';

export function formatDocumentTitle(title?: string | null) {
    const trimmedTitle = title?.trim();
    return trimmedTitle ? `${trimmedTitle} – ${APP_DOCUMENT_TITLE}` : APP_DOCUMENT_TITLE;
}

export function useDocumentTitle(title?: string | null) {
    useEffect(() => {
        const previous = document.title;
        document.title = formatDocumentTitle(title);
        return () => {
            document.title = previous;
        };
    }, [title]);
}
